<template lang="pug">
  .button
    span.button-text Share this page
    span
</template>

<script>
export default {
  
}
</script>

<style lang="sass">
.button
  height: 56px
  background-color: #14b945
  margin-left: -18px
  margin-right: -18px
  color: white
  display: flex
  justify-content: center
  align-items: center
  margin-top: 88px
  &-text
    font-size: 16px
    font-weight: bold
  
</style>